/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'multiselect-deselected': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm0 2C5.37 24 0 18.63 0 12S5.37 0 12 0s12 5.37 12 12-5.37 12-12 12z" fill-rule="evenodd" clip-rule="evenodd" _fill="#231f20"/>'
  }
})
